import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';

export class NetworkV2AppBaseDataProvider extends BaseWebComponentDataProvider {}
